import { SettingsRepository } from './ports/SettingsRepository';
import { SupabaseSettingsRepository } from '@infrastructure/supabase/SupabaseSettingsRepository';

class SettingsDomainFactory {
  private repository: SettingsRepository;

  constructor() {
    this.repository = new SupabaseSettingsRepository();
  }

  getRepository() {
    return this.repository;
  }
}

export const settingsDomain = new SettingsDomainFactory();
